import { render, staticRenderFns } from "./PageFaq.vue?vue&type=template&id=f1caa7b0&"
import script from "./PageFaq.vue?vue&type=script&lang=js&"
export * from "./PageFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports